
const COS = require('cos-js-sdk-v5')
// 组件式
const uploadMixin = {
  data() {
    return {
      uploadLoacalUrl: '',
      uploadMixinPath: '',
      uploadMixinType: '',
      uploadMixinCredentials: {},
      uploadMixinTimeStamp: 0 // new Date().getTime()
    }
  },
  methods: {
    async upLoadHander(obj, needCheckExif = false) {

      let { file } = obj
      let fileName = []
      if (file.name) {
        fileName = file.name.split('.')
      } else {
        fileName = ['blob', file.type.split('/')[1]]
      }

      let fileInfo = {
        fileTyle: fileName.length > 1 ? fileName[fileName.length - 1] : '',
        fileName: fileName[0],
        biz: obj.data.biz,
        file: file
      }
      console.log(obj)
      // 上传函数
      const that = this
      async function hander(noCredentials) {
        let res
        if (noCredentials) {
          res = await that.$axios.get('/sys/ext/getUploadConfigInfo')
		  console.log(res)
          if (res.code === 200 && res.result) {
            that.uploadMixinPath = res.result.upLoadPath
            that.uploadMixinType = res.result.uploadType
            if (that.uploadMixinType === 'txcos') {
              const ress = res.result.response
              const credentials = ress.credentials
              that.uploadMixinCredentials = {
                TmpSecretId: credentials.tmpSecretId,
                TmpSecretKey: credentials.tmpSecretKey,
                SecurityToken: credentials.sessionToken,
                StartTime: ress.startTime,
                ExpiredTime: ress.expiredTime
              }
            }
          } else {
            that.$message.error(res.message || '服务接口报错')
            return
          }
        }
        if (that.uploadMixinType === 'txcos') {
          // 直接上传文件到cdn服务器
          const cos = new COS({
            getAuthorization: (options, callback) => {
              callback(that.uploadMixinCredentials)
            }
          })
          // 文件存放目录：/tax（api）/user_id（19位）/【年+时间戳（17位）+ 随机数（4位）】
          let tempFolder = `${userId}/`
          // if (['png', 'jpg', 'svg', 'jpeg', 'gif'].includes(fileInfo.fileTyle)) {
          //   tempFolder = 'image/'
          // }
          const folder = `${new Date().getFullYear()}${new Date().getTime()}${randomNumber(4)}.${fileInfo.fileTyle}`
          cos.putObject(
            {
              Bucket: res.result.bucketName || 'tikcos-1257774783',
              Region: res.result.regionid || 'ap-guangzhou',
              Key: that.uploadMixinPath + tempFolder + folder,
              Body: fileInfo.file,
              onProgress: function (progressData) {
                console.log('upLoadHander-onProgress:', JSON.stringify(progressData))
                obj.onProgress(progressData)
              }
            },
            (err, data) => {
              console.log(err || data)
              if (!err && data.statusCode === 200) {
                let imgurl = `${that.uploadMixinPath}${tempFolder}${folder}`
                obj.onSuccess({ success: true, message: imgurl })
              } else {
                obj.onError({ success: false, message: err || '图片上传失败' })
              }
            }
          )
        } else {
          // 原本的文件上传
          let formData = new FormData()
          let paramKeys = Object.keys(obj.data || {})
          if (paramKeys.length > 0) {
            paramKeys.forEach(key => {
              formData.append(key, obj.data[key])
            })
          }

          formData.append(obj.filename || 'file', fileInfo.file)
          // const uploadRes = await that.$axios.post('/app/platform/uploadFile', formData, { // 后端不存在此接口，已注释
          const uploadRes = await that.$axios.post('/sys/common/upload', formData, {
            headers: { ...obj.headers },
            processData: false,
            contentType: false,
            async: false
          })
          if (uploadRes.success) {
            obj.onSuccess(uploadRes)
          } else {
            obj.onError(uploadRes)
          }
        }
      }
        hander(false)

    },
    checkExifImage(fileInfo, needCheckExif, callback) {
      if (!needCheckExif) {
        callback()
        return
      }
      // 处理特殊图片的偏移问题
      const that = this
      function fileToBuf(file, callback) {
        let reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.addEventListener(
          'loadend',
          e => {
            let buf = e.target.result
            callback(buf)
          },
          false
        )
      }
      function checkOrientationImage(img, orientation, width, height, callback) {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        ctx.save()

        switch (orientation) {
          case 2:
            canvas.width = width
            canvas.height = height
            ctx.translate(width, 0)
            ctx.scale(-1, 1)
            break
          case 3:
            canvas.width = width
            canvas.height = height
            ctx.translate(width / 2, height / 2)
            ctx.rotate((180 * Math.PI) / 180)
            ctx.translate(-width / 2, -height / 2)
            break
          case 4:
            canvas.width = width
            canvas.height = height
            ctx.translate(0, height)
            ctx.scale(1, -1)
            break
          case 5:
            canvas.height = width
            canvas.width = height
            ctx.rotate(0.5 * Math.PI)
            ctx.scale(1, -1)
            break
          case 6:
            canvas.width = height
            canvas.height = width
            ctx.translate(height / 2, width / 2)
            ctx.rotate((90 * Math.PI) / 180)
            ctx.translate(-width / 2, -height / 2)
            break
          case 7:
            canvas.height = width
            canvas.width = height
            ctx.rotate(0.5 * Math.PI)
            ctx.translate(width, -height)
            ctx.scale(-1, 1)
            break
          case 8:
            canvas.height = width
            canvas.width = height
            ctx.translate(height / 2, width / 2)
            ctx.rotate((-90 * Math.PI) / 180)
            ctx.translate(-width / 2, -height / 2)
            break
          default:
            canvas.width = width
            canvas.height = height
        }

        ctx.drawImage(img, 0, 0, width, height)
        ctx.restore()
        canvas.toBlob(blob => {
          fileInfo.file = blob
          URL.revokeObjectURL(that.uploadLoacalUrl)
          callback()
        })
      }
      const fileTyle = (fileInfo.fileTyle || '').toLowerCase()
      if ('jpg,jpeg,png'.indexOf(fileTyle) > -1) {
        fileToBuf(fileInfo.file, buf => {
          const exitInfo = EXIF.readFromBinaryFile(buf)
          if (exitInfo.Orientation && exitInfo.Orientation != 1) {
            const dataView = new DataView(buf)
            const position = exitInfo.OrientationOffset + 8
            dataView.setUint16(position, 1)

            that.uploadLoacalUrl = URL.createObjectURL(new Blob([buf]))

            let img = new Image()
            img.onload = () => {
              let width = img.width
              let height = img.height
              const max = 1200
              if (width > max) {
                height = (height / width) * max
                width = max
              }

              if (height > max) {
                width = (width / height) * max
                height = max
              }
              checkOrientationImage(img, exitInfo.Orientation, width, height, callback)
            }
            img.onerror = () => {
              console.log('imgLoad error')
            }
            img.src = that.uploadLoacalUrl
          } else {
            callback()
          }
        })
      } else {
        callback()
      }
    },
    batchDownload(imgSrcList, name) {
      const arr = imgSrcList.map((item, index) => {
        return {
          fileUrl: item.fileAddress,
          renamefileName: this.getFileName(item.fileAddress, item.fileName.replace(/\//g, '-'))
        }
      })
      this.unpack(arr, name)
    },
    batchDownloadHZ(imgSrcList, name) {
      const arr = imgSrcList.map((item, index) => {
        if (item.fileAddress && item.fileName) {
          return {
            fileUrl: item.fileAddress,
            renamefileName: this.getFileName(item.fileAddress, item.fileName.replace(/\//g, '-'))
          }
        }
      })
      this.unpack(arr, name)
    },
    unpack(arr, name) {
      let fileName = name
      const _this = this
      const zip = new JSZip()
      const cache = {}
      const list = []
      arr.forEach((item) => {
        const promise = _this.getImgArrayBuffer(item.fileUrl).then((data) => {
          // 下载文件, 并存成ArrayBuffer对象(blob)
          //this.$message.loading({ content: `正在导出${item.renamefileName},请等待...`, key: item.id })
          if (this.setLoading) this.setLoading(true)
          zip.file(item.renamefileName, data, { binary: true }) // 逐个添加文件
          cache[item.renamefileName] = data
        })
        list.push(promise)
      })
      console.log(arr, list, '111', 'Data')
      Promise.all(list).then(() => {
        zip
          .generateAsync({ type: 'blob' })
          .then((content) => {
            // 生成二进制流
            console.log('生成二进制流', content, fileName);
            FileSaver.saveAs(content, fileName) // 利用file-saver保存文件  自定义文件名
            if (this.setLoading) this.setLoading(false)
            _this.$message.success('压缩完成')
          })
          .catch((res) => {
            _this.$message.error('文件压缩失败')
          })
      })
    },
    getImgArrayBuffer(urls) {
      let url = getBatchAgentUrl(urls)
      return new Promise((resolve, reject) => {
        const xmlhttp = new XMLHttpRequest()
        xmlhttp.open('GET', url, true)
        xmlhttp.responseType = 'arraybuffer'
        xmlhttp.onload = function () {
          if (this.status === 200) {
            resolve(this.response)
          } else {
            reject(this.status)
          }
        }
        xmlhttp.send()
      })
    },

    getFileName(url, file) {
      var num = url.lastIndexOf('.')
      var filePrefix = file.split(".")
      var fileName = filePrefix[0] + url.substring(num)
      //把参数和文件名分割开
      fileName = decodeURI(fileName.split("?")[0]);
      return fileName;
    },
  }
}
export { uploadMixin }
